import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=1a412bf3&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"
import style0 from "./Background.vue?vue&type=style&index=0&id=1a412bf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a412bf3",
  null
  
)

export default component.exports